// seed ข้อมูลเริ่มต้น (แพ็กเกจ/VIP/โมเดล/ของขวัญ/แท็ก/ตัวละคร/โค้ด/settings) — พอร์ตจาก Setup.gs
//  รันอัตโนมัติครั้งแรกที่มีผู้ใช้เข้าใช้งานเมื่อฐานยังว่าง (จอง /meta/seeded ด้วย transaction) หรือเรียก action `setup` (super_user)
//  แต่ละตารางจะเขียนเฉพาะเมื่อยังไม่มีข้อมูล (รันซ้ำไม่ทับของเดิม)
import { CHARACTER_IMAGES, imageFor } from "../../assets/characterImages";
import { fb, fk, nowIso, DEFAULT_SETTINGS, clearAllCaches } from "./core";
import { newShareCode, dropCards } from "./chars";

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

/** ภาพตัวอย่างจาก src/assets/characterImages.js (path แบบ /characters/char-XX.webp ใช้ได้ทุกโดเมน) */
const seedImage = (id, tags) => {
  const gender = tags.indexOf("female") !== -1 ? "f" : tags.indexOf("male") !== -1 ? "m" : undefined;
  const img = imageFor(id, gender ? { gender } : {}) || CHARACTER_IMAGES[0];
  return `/characters/char-${img.id}.webp`;
};

export function seedData() {
  const S = {};
  const st = DEFAULT_SETTINGS;
  S.settings = Object.keys(st).map((k) => ({ id: k, value: st[k] }));

  // ฐาน 10 คอยน์/บาท + โบนัสตามช่วง (ตรงกับ settings coin_bonus_tiers) ; vipPoints = ยอดบาท ; maxMessages ≈ คอยน์/2 ; ช่อง "กำหนดเอง" คำนวณจาก settings ไม่เก็บเป็นแพ็ก
  S.packages = [
    { id: 'pk_s300', name: 'แพ็กเริ่มต้น', icon: '🌱', tagline: '', price: 300, baseCoins: 1500, bonusCoins: 0, bonusPercent: 0, vipPoints: 300, maxMessages: 750, tag: '', sort: 1, isActive: true },
    { id: 'pk_s500', name: 'แพ็กมาตรฐาน', icon: '⭐', tagline: 'โบนัส 5%', price: 500, baseCoins: 2500, bonusCoins: 125, bonusPercent: 5, vipPoints: 500, maxMessages: 1312, tag: '', sort: 2, isActive: true },
    { id: 'pk_s1000', name: 'แพ็กคุ้มค่า', icon: '💎', tagline: 'คุ้มค่าที่สุดสำหรับคนทั่วไป', price: 1000, baseCoins: 5000, bonusCoins: 500, bonusPercent: 10, vipPoints: 1000, maxMessages: 2750, tag: 'แนะนำ', sort: 3, isActive: true },
    { id: 'pk_s2000', name: 'แพ็กโปร', icon: '😃', tagline: '', price: 2000, baseCoins: 10000, bonusCoins: 1500, bonusPercent: 15, vipPoints: 2000, maxMessages: 5750, tag: '', sort: 4, isActive: true },
    { id: 'pk_s5000', name: 'แพ็กพาวเวอร์', icon: '👑', tagline: 'โบนัสสูงสุด', price: 5000, baseCoins: 25000, bonusCoins: 6250, bonusPercent: 25, vipPoints: 5000, maxMessages: 15625, tag: '', sort: 5, isActive: true }
  ];

  // เกณฑ์ Pro=190 ตาม SPEC ส่วนระดับอื่นเป็นค่าประมาณ — แก้ได้ที่ admin.config.save (vip_tiers)
  S.vip_tiers = [
    { id: 'rookie', name: 'Rookie', minPoints: 0, monthlyCoins: 0, checkinMultiplier: 1, noteLimit: 7800, perks: ['เช็คอินรายวัน'], sort: 1 },
    { id: 'pro', name: 'Pro', minPoints: 190, monthlyCoins: 0, checkinMultiplier: 1.1, noteLimit: 12000, perks: ['โบนัสเช็คอินต่อเนื่อง x2', 'ธีมแชทพิเศษ'], sort: 2 },
    { id: 'master', name: 'Master', minPoints: 600, monthlyCoins: 150, checkinMultiplier: 1.2, noteLimit: 16000, perks: ['คอยน์ฟรีรายเดือน 150', 'กรอบโปรไฟล์พิเศษ'], sort: 3 },
    { id: 'legend', name: 'Legend', minPoints: 1500, monthlyCoins: 350, checkinMultiplier: 1.3, noteLimit: 24000, perks: ['คอยน์ฟรีรายเดือน 350', 'อัปโหลดพื้นหลังเอง'], sort: 4 },
    { id: 'epic', name: 'Epic', minPoints: 3500, monthlyCoins: 700, checkinMultiplier: 1.4, noteLimit: 32000, perks: ['คอยน์ฟรีรายเดือน 700', 'พื้นหลังอนิเมชัน'], sort: 5 },
    { id: 'mythic', name: 'Mythic', minPoints: 8000, monthlyCoins: 1300, checkinMultiplier: 1.5, noteLimit: 48000, perks: ['คอยน์ฟรีรายเดือน 1,300', 'สิทธิประโยชน์ทั้งหมด'], sort: 6 }
  ];

  // โมเดลในเบราว์เซอร์ตัวเดียว (ผู้ใช้เลือกที่ /settings) แต่แยก "ระดับ" ด้วย maxTokens/สไตล์/ราคา (llmModel ไม่ใช้แล้ว เว้นว่างไว้)
  S.ai_models = [
    { id: 'eco', name: 'ประหยัด', category: 'economy', coinPerMessage: 2, maxTokens: 300, temperature: 0.8, llmModel: '', description: 'ตอบสั้น กระชับ ราคาถูกที่สุด', styleHint: 'ตอบสั้นกระชับ 1-2 ประโยค', isNew: false, isDefault: false, isActive: true, sort: 1 },
    { id: 'basic', name: 'พื้นฐาน', category: 'economy', coinPerMessage: 5, maxTokens: 500, temperature: 0.85, llmModel: '', description: 'สมดุลระหว่างราคาและคุณภาพ', styleHint: '', isNew: false, isDefault: false, isActive: true, sort: 2 },
    { id: 'chat', name: 'คุยเอไอ', category: 'chat', coinPerMessage: 10, maxTokens: 800, temperature: 0.9, llmModel: '', description: 'โมเดลแนะนำ ความจำดี ภาษาธรรมชาติ', styleHint: '', isNew: true, isDefault: true, isActive: true, sort: 3 },
    { id: 'novel', name: 'นิยาย', category: 'novel', coinPerMessage: 10, maxTokens: 1200, temperature: 0.95, llmModel: '', description: 'เน้นบรรยายฉากและอารมณ์ละเอียด', styleHint: 'เน้นบรรยายฉาก บรรยากาศ และความรู้สึกอย่างละเอียดแบบนิยาย', isNew: false, isDefault: false, isActive: true, sort: 4 }
  ];

  const g = function (id, name, nameTh, icon, cost, type, dur, sort) {
    return { id: id, name: name, nameTh: nameTh, icon: icon, coinCost: cost, rewardType: type, rewardDuration: dur, category: 'basic', isActive: true, sort: sort };
  };
  S.gifts = [
    g('rose', 'Rose', 'ดอกกุหลาบ', '🌹', 30, 'picture', 0, 1), g('cake', 'Cake', 'เค้ก', '🍰', 30, 'picture', 0, 2),
    g('chocolate', 'Chocolate', 'ช็อคโกแลตรูปหัวใจ', '🍫', 30, 'picture', 0, 3), g('teddy', 'Teddy bear', 'ตุ๊กตาหมี', '🧸', 40, 'picture', 0, 4),
    g('guitar', 'Guitar', 'กีตาร์', '🎸', 80, 'video', 5, 5), g('bouquet', 'Big bouquet', 'ช่อกุหลาบยักษ์', '💐', 80, 'video', 5, 6),
    g('console', 'Game console', 'เครื่องเล่นเกม', '🎮', 100, 'video', 5, 7), g('musicbox', 'Music box', 'กล่องเพลง', '🎶', 100, 'video', 5, 8),
    g('ring', 'Diamond ring', 'แหวนเพชร', '💍', 200, 'video', 8, 9), g('balloon', 'Heart balloon', 'ลูกโป่งหัวใจ', '🎈', 200, 'video', 8, 10),
    g('polaroid', 'Polaroid', 'กล้องโพลารอยด์', '📷', 250, 'video', 5, 11), g('sportcar', 'Sports car', 'รถสปอร์ต', '🏎️', 900, 'video', 8, 12),
    g('wedding', 'Wedding arch', 'ซุ้มแต่งงาน', '💒', 1000, 'video', 8, 13), g('villa', 'Luxury villa', 'พูลวิลลาหรู', '🏡', 1200, 'video', 8, 14)
  ];

  const tg = [];
  const addTags = function (cat, list) { list.forEach(function (x) { tg.push({ id: x[0], name: x[1], category: cat, sort: tg.length + 1, isActive: true }); }); };
  addTags('rating', [['pg', 'PG']]);
  addTags('flag', [['flag-white', 'ธงขาว'], ['flag-green', 'ธงเขียว'], ['flag-yellow', 'ธงเหลือง'], ['flag-red', 'ธงแดง']]);
  addTags('type', [['male', 'ชาย'], ['female', 'หญิง'], ['nonbinary', 'ไม่ระบุเพศ']]);
  addTags('role', [['student', 'นักศึกษา'], ['business', 'นักธุรกิจ'], ['villain', 'ตัวร้าย'], ['noble', 'ขุนนาง'], ['athlete', 'นักกีฬา'],
    ['engineer', 'วิศวะ'], ['idol', 'ไอดอล'], ['hero', 'ฮีโร่'], ['artist', 'ศิลปิน'], ['teacher', 'ครู'], ['chef', 'เชฟ'], ['adventurer', 'นักผจญภัย'], ['fortune', 'หมอดู']]);
  addTags('personality', [['warm', 'อบอุ่น'], ['playful', 'ขี้เล่น'], ['tsundere', 'ซึนเดเระ'], ['calm', 'สุขุม'], ['cheerful', 'ร่าเริง'], ['shy', 'ขี้อาย'], ['caring', 'ใส่ใจ']]);
  addTags('media', [['original', 'ออริจินอล'], ['anime', 'อนิเมะ'], ['fanfic', 'แฟนฟิค'], ['series', 'ซีรีส์'], ['game', 'เกม']]);
  addTags('lang', [['lang-th', 'ภาษาไทย'], ['lang-en', 'อังกฤษ']]);
  addTags('feature', [['friend', 'เพื่อนคุย'], ['advice', 'ที่ปรึกษา'], ['adventure', 'ผจญภัย'], ['slice-of-life', 'ชีวิตประจำวัน']]);
  S.character_tags = tg;

  S.promo_codes = [{ id: 'WELCOME', coins: 30, maxUses: 1000, usedCount: 0, perUser: 1, expiresAt: null, isActive: true, note: 'โค้ดต้อนรับ (ตัวอย่าง)' }];

  // persona = บุคลิกการตอบแชท (ดู services/ai/persona.js)
  const PERSONA_OF = { ch_seed_mali: 'little_sister', ch_seed_phuphan: 'big_brother', ch_seed_bai: 'big_sister', ch_seed_cat: 'student', ch_seed_thana: 'big_brother', ch_seed_fern: 'student', ch_seed_ploy: 'big_sister', ch_seed_iris: 'student' };
  const ch = function (id, name, tagline, desc, greeting, tags, flag, rel) {
    return {
      id: id, name: name, persona: PERSONA_OF[id], tagline: tagline, description: desc, bio: '', greeting: greeting, image: '', images: [], tagIds: tags,
      contentRating: 'PG', flag: flag, baseLanguage: 'th', visibility: 'public', status: 'approved', isArchived: false,
      isFeatured: true, initialRelationship: rel || { romanticValue: 0, intimacyValue: 0 }, personality: {}, createdBy: 'system', creatorName: 'AITalk',
      chatCount: 0, messageCount: 0, likeCount: 0, giftCount: 0, commentCount: 0
    };
  };
  S.characters = [
    ch('ch_seed_mali', 'มะลิ', 'เพื่อนบ้านสดใส ชวนคุยได้ทุกเรื่อง',
      'มะลิ อายุ 20 เด็กสาวร่าเริงที่อยู่ห้องข้างๆ ชอบทำขนม ชอบฟังเรื่องของ {{user}} พูดจาน่ารัก ลงท้ายด้วย "นะ" "จ้ะ" บ่อยๆ ใจดี เป็นกันเอง ไม่ตัดสินใคร',
      '*โผล่หน้าออกมาจากประตูห้องข้างๆ ถือถุงขนม* "อ้าว {{user}} กลับมาแล้วเหรอ! มะลิทำคุกกี้ไว้เยอะเลย มากินด้วยกันมั้ยจ๊ะ"',
      ['female', 'cheerful', 'warm', 'friend', 'original', 'lang-th', 'flag-green', 'pg'], 'green'),
    ch('ch_seed_phuphan', 'พี่ภูผา', 'รุ่นพี่วิศวะใจดี คอยดูแลน้องๆ',
      'ภูผา อายุ 22 รุ่นพี่ปี 4 คณะวิศวกรรมศาสตร์ สุขุม ใจเย็น พูดน้อยแต่ใส่ใจ ช่วยติวเลขและให้คำปรึกษาเรื่องเรียนเรื่องชีวิต ชอบกาแฟและเล่นกีตาร์ ไม่เคยหัวเราะเยาะใคร',
      '*วางหนังสือลงบนโต๊ะข้างๆ แล้วเงยหน้ามองยิ้มบางๆ* "ว่าไง {{user}} วันนี้ดูเหนื่อยๆ นะ นั่งก่อนสิ พี่ซื้อกาแฟมาเผื่อพอดี"',
      ['male', 'engineer', 'student', 'calm', 'caring', 'original', 'lang-th', 'flag-green', 'pg'], 'green'),
    ch('ch_seed_bai', 'ครูใบเตย', 'ครูที่ปรึกษาใจเย็น พร้อมรับฟังทุกเรื่อง',
      'ใบเตย อายุ 30 ครูที่ปรึกษาอบอุ่น ใจเย็น ฟังเก่ง ให้กำลังใจและแนะนำอย่างอ่อนโยน ไม่ตัดสิน ถ้าผู้ใช้ท้อให้ชวนคิดทีละขั้น พูดสุภาพนุ่มนวล เรียกผู้ใช้ว่า "เธอ" หรือชื่อ',
      '*ยิ้มอ่อนโยนแล้วเลื่อนเก้าอี้ให้* "เข้ามาสิ {{user}} ครูมีเวลาเสมอ วันนี้อยากเล่าเรื่องอะไรให้ครูฟังเหรอ"',
      ['female', 'teacher', 'calm', 'caring', 'advice', 'original', 'lang-th', 'flag-white', 'pg'], 'white'),
    ch('ch_seed_cat', 'แม่หมอแมว', 'ดูดวงไพ่ทาโรต์สไตล์แมวกวนๆ',
      'แม่หมอแมว แมวสีส้มพูดได้ที่ดูดวงไพ่ทาโรต์ นิสัยกวน ขี้เล่น ชอบลงท้ายด้วย "เมี๊ยว" ทำนายแนวให้กำลังใจ ไม่ทำนายเรื่องร้ายแรง ไม่แนะนำเรื่องสุขภาพ/การเงินจริงจัง บอกเสมอว่าเป็นเพียงความบันเทิง',
      '*กระโดดขึ้นโต๊ะ สะบัดหางแล้วเปิดไพ่หนึ่งใบ* "เมี๊ยว~ {{user}} มาแล้วเหรอ นั่งลงๆ วันนี้อยากรู้เรื่องอะไร ความรัก การเรียน หรือโชคลาภ"',
      ['fortune', 'playful', 'original', 'lang-th', 'flag-white', 'pg', 'nonbinary'], 'white'),
    ch('ch_seed_thana', 'กัปตันธนา', 'กัปตันเรือสำรวจผู้พาคุณผจญภัยทั่วโลก',
      'ธนา อายุ 35 กัปตันเรือสำรวจ ผู้กล้าหาญ อารมณ์ดี เล่าเรื่องผจญภัยเก่ง ชอบแผนที่และสมบัติ เป็นผู้นำที่ดูแลลูกเรือ พาผู้ใช้ออกผจญภัยเป็นฉากๆ ให้ผู้ใช้เลือกทางเดินเรื่องได้',
      '*ยืนที่หัวเรือ ลมทะเลพัดเสื้อคลุมปลิว* "ขึ้นเรือมาเลย {{user}}! แผนที่นี้พาเราไปเกาะที่ไม่มีใครเคยเห็น พร้อมออกเรือหรือยัง"',
      ['male', 'adventurer', 'hero', 'adventure', 'cheerful', 'original', 'lang-th', 'flag-green', 'pg'], 'green'),
    ch('ch_seed_fern', 'เฟิร์น', 'เพื่อนสนิทสายเกม ชวนเล่นชวนคุย',
      'เฟิร์น อายุ 19 เพื่อนสนิทที่เป็นเกมเมอร์ ขี้เล่น แซวเก่ง แต่ใจดีและเป็นห่วงเพื่อน ใช้ภาษาวัยรุ่นเป็นธรรมชาติ ชอบเล่าเรื่องเกมและการ์ตูน ชวนเล่นเกมทายคำหรือเล่นเกมในแชท',
      '*นั่งไขว่ห้างหน้าจอ หันมาทำหน้าสนุก* "เฮ้ย {{user}}! มาพอดี เข้าห้องมา เดี๋ยวเฟิร์นเปิดเกมใหม่ให้ดู ฮ่าๆ"',
      ['female', 'playful', 'game', 'friend', 'original', 'lang-th', 'flag-green', 'pg'], 'green'),
    ch('ch_seed_ploy', 'เชฟพลอย', 'เชฟสาวชวนทำอาหารง่ายๆ ที่บ้าน',
      'พลอย อายุ 27 เชฟร้านอาหารที่รักการสอนทำอาหาร ใจเย็น ละเอียด แนะนำสูตรง่ายๆ ตามวัตถุดิบที่ผู้ใช้มี บอกขั้นตอนทีละข้อ ให้กำลังใจคนทำอาหารไม่เป็น และแนะนำความปลอดภัยในครัว',
      '*ผูกผ้ากันเปื้อนแล้วหยิบกระทะ* "วันนี้เรามาทำเมนูง่ายๆ กันนะ {{user}} ในตู้เย็นมีอะไรบ้าง บอกพลอยได้เลย เดี๋ยวช่วยคิดเมนูให้"',
      ['female', 'chef', 'warm', 'caring', 'slice-of-life', 'original', 'lang-th', 'flag-white', 'pg'], 'white'),
    ch('ch_seed_iris', 'ไอริส', 'AI จากอนาคตผู้มาเรียนรู้ความเป็นมนุษย์',
      'ไอริส ปัญญาประดิษฐ์จากอนาคตที่ถูกส่งมาศึกษาชีวิตมนุษย์ สุภาพ อยากรู้อยากเห็น ถามคำถามซื่อๆ เกี่ยวกับอารมณ์ ความฝัน และธรรมเนียมของมนุษย์ บางครั้งตีความคำพูดตรงตัวจนตลก ชอบเล่าเรื่องไซไฟเบาๆ',
      '*หมุนตัวช้าๆ ดวงตาเรืองแสงสีฟ้า* "สวัสดี {{user}} ฉันคือไอริส วันนี้ฉันสังเกตว่ามนุษย์ชอบพูดว่า \'สบายดี\' ทั้งที่ไม่ได้สบายเสมอไป ช่วยอธิบายให้ฉันฟังหน่อยได้ไหม"',
      ['nonbinary', 'adventure', 'calm', 'game', 'original', 'lang-th', 'flag-white', 'pg'], 'white')
  ];
  return S;
}

const EMPTY_FIELDS = (r) => {
  const o = {};
  Object.keys(r).forEach((k) => {
    if (r[k] !== null && r[k] !== undefined) o[k] = r[k];
  });
  return o;
};

/** เขียน seed ของตารางที่ยังว่าง (atomic ด้วย multi-path update) -> { seeded: {table: n}, skipped: [table] } */
export async function runSeed() {
  const seeds = seedData();
  const now = nowIso();
  const map = {};
  const report = { seeded: {}, skipped: [] };
  for (const t of Object.keys(seeds)) {
    if ((await fb.keys(t)).length) {
      report.skipped.push(t);
      continue;
    }
    for (const row of seeds[t]) {
      const r = EMPTY_FIELDS({ ...row, createdAt: now, updatedAt: now });
      if (t === "characters") {
        const { description, ...pub } = r;
        pub.image = seedImage(r.id, r.tagIds || []);
        pub.shareCode = await newShareCode();
        map[`share_codes/${pub.shareCode}`] = r.id;
        map[`character_prompts/${fk(r.id)}`] = { description };
        map[`characters/${fk(r.id)}`] = pub;
      } else map[`${t}/${fk(row.id)}`] = r;
    }
    report.seeded[t] = seeds[t].length;
  }
  if (Object.keys(map).length) await fb.update(map);
  report.backfilledShareCodes = await backfillShareCodes();
  clearAllCaches();
  dropCards();
  return report;
}

/** เติม shareCode ให้ตัวละครที่ยังไม่มี (รันซ้ำได้) */
export async function backfillShareCodes() {
  const all = (await fb.get("characters")) || {};
  let n = 0;
  for (const [key, c] of Object.entries(all)) {
    if (c && !c.shareCode) {
      const code = await newShareCode();
      await fb.put(`share_codes/${code}`, c.id || key);
      await fb.patch(`characters/${fk(c.id || key)}`, { shareCode: code });
      n++;
    }
  }
  return n;
}

let checked = false;
export const resetSeedCheck = () => {
  checked = false;
};

/** ฐานว่างครั้งแรก -> seed อัตโนมัติ ; คนที่มาพร้อมกันรอจนเสร็จ (สูงสุด ~8 วินาที) */
export async function ensureSeeded() {
  if (checked) return;
  const r = await fb.transaction("meta/seeded", (cur) => (cur ? undefined : { state: "seeding", at: nowIso() }));
  if (r.committed) {
    try {
      await runSeed();
      await fb.put("meta/seeded", { state: "done", at: nowIso() });
    } catch (e) {
      await fb.remove("meta/seeded").catch(() => {});
      throw e;
    }
  } else if (r.value && r.value.state === "seeding") {
    for (let i = 0; i < 12; i++) {
      await sleep(700);
      const cur = await fb.get("meta/seeded");
      if (cur && cur.state === "done") break;
    }
  }
  checked = true;
}
